import { Injectable } from '@angular/core';
import { LayoutService } from './layout.service';
import { Widget } from '../models/widget';
import { map, take } from 'rxjs/operators';
import { LayoutItem, TEMPLATE_TYPE } from '../models/template';
import { WidgetService } from 'app/main/widgets/widget.service';
import { Subject } from '../models/subject';
import { Observable } from 'rxjs';
import { Layout } from '../models/layout';
import { CurrencyPipe } from '@angular/common';

@Injectable()
export class SubjectLayoutService {
  constructor(
    private layoutService: LayoutService,
    private widgetService: WidgetService
  ) {}

  getSubjectCardWidgets(subject: Subject): Observable<any> {
    return this.layoutService
      .getLayout(subject.subjectTypeId, subject.categoryId)
      .pipe(
        take(1),
        map((response: Layout) => {
          const layout = response;
          const widgets: Widget[] = [];
          let size;
          subject = new Subject(subject);          
          if (layout) {
            // call getTemplate which will ensure we have a valid card template to use
            this.layoutService
              .getTemplate(
                layout,
                subject.isReferral
                  ? TEMPLATE_TYPE.REFERRALCARD
                  : TEMPLATE_TYPE.CARD
              )
              .subscribe();
            // get the layoutitems from the card template
            this.widgetService
              .getSortedLayoutItems(
                subject.isReferral &&
                  layout.referralCardTemplate &&
                  layout.referralCardTemplate.layoutItems &&
                  layout.referralCardTemplate.layoutItems.length > 0
                  ? layout.referralCardTemplate.layoutItems
                  : layout.cardTemplate.layoutItems
              )
              .forEach((item) => {
                const dataField = layout.subjectType.getDataField(item.name);
                if (dataField) {
                  const widget = this.widgetService.fieldAsWidget(
                    undefined,
                    dataField,
                    item.layoutInformation
                  );
                  widget.type = item.type || 'LABEL';
                  const type = this.widgetService.getWidgetType(widget.type);
                  widget.widget = this.widgetService.getWidget(type);
                  widget.metadata.value = widget.metadata.label;
                  widgets.push(widget);
                } else {
                  let widget;
                  switch (item.name.toLowerCase()) {
                    case 'line':
                      widget = this.widgetService.getLineWidget(99);
                      break;
                    case 'text':
                      widget = this.widgetService.getHtmlWidget(98);
                      break;
                    default:
                      break;
                  }
                  if (widget) {
                    widget.config = item.layoutInformation;
                    const widgetType = this.widgetService.getWidgetType(
                      widget.type
                    );
                    widget.widget = this.widgetService.getWidget(widgetType);
                    widgets.push(widget);
                  }
                }
              });

            size = layout.cardTemplate.getSize();

            // set all fieldvalue widgets to blank...
            widgets
              .filter(
                (layoutItem) => layoutItem.type.toLowerCase() === 'fieldvalue'
              )
              .forEach((w) => (w.metadata.value = ''));

            // now populate the widgets with the correct values
            subject.getMetadata(layout).forEach((item) => {
              const itemsToUpdate = widgets.filter(
                (layoutItem) =>
                  layoutItem.id === item.id &&
                  layoutItem.type.toLowerCase() === 'fieldvalue'
              );
              // console.log('Item to update:', itemsToUpdate, item.id);
              if (itemsToUpdate) {
                // value=value or lookup id, displayValue=value or lookup description.  We therefore set the metadata value to the value of the displayValue
                itemsToUpdate.forEach((w) => {
                  w.metadata.value = item.displayValue;
                  w.metadata.type = item.type;
                });
              }
            });
          }
          return {
            widgets,
            x: size.x,
            y: size.y,
          };
        })
      );
  }
}
